angular.module("vgresiduos").controller("secondNavBarCtrl", [
	"$scope",
	"accountService",
	"$rootScope",
	"vertownAgentService",
	"$stateParams",
	"$location",
	function ($scope, accountService, $rootScope, vertownAgentService, $stateParams, $location) {
		"use strict";

		let _hasVertownAgentAccess = false;
		let _forceRecreation = false;

		this.$onInit = function () {
			$scope.ctrl.activeOption = "allUsers";
			resetAll();
		};

		$scope.openUserMenu = function () {
			$rootScope.$broadcast(Vgr.constants.evtOpenUserMenu);
		};

		$scope.openAgentBar = function (initialMessage) {
			if (_hasVertownAgentAccess) {
				vertownAgentService.recreate(_forceRecreation, initialMessage);
				$rootScope.$broadcast(Vgr.constants.evtOpenAgentBar);
				_forceRecreation = false;
			}
		};

		$scope.hasVertownAgentAccess = function () {
			return _hasVertownAgentAccess;
		};

		function checkVertownAgentAccess() {
			_hasVertownAgentAccess = false;

			if (accountService.isSupplier()) {
				return;
			}
			const promise = vertownAgentService.getVertownAgentAccess();
			if (!promise) {
				return;
			}
			promise.then(function (response) {
				_hasVertownAgentAccess = !!response.data.credentials;
				_forceRecreation = true;

				if ($stateParams.menu == Vgr.enumerations.homeMenu.vertownAgent) {
					$scope.openAgentBar();
				}
			});
		}

		window.addEventListener("click", function (e) {
			const navBar = document.getElementById("navBar");
			const toggleButton = document.getElementById("toggleButton");
			const search = document.getElementById("companyChangeMenu"); //search menu
			if (navBar && toggleButton) {
				if (navBar.contains(e.target) || toggleButton.contains(e.target) || (search && search.contains(e.target))) {
					//do nothing
				} else {
					$scope.$apply();
				}
			}
		});

		function resetAll() {
			$scope.loggedUser = accountService.getLoggedAccount();
			$scope.loggedClient = accountService.getCurrentClient();
			checkVertownAgentAccess();
		}

		const onChangeLoggedUserInfo = $rootScope.$on(Vgr.constants.evtChangeLoggedUserInfo, function () {
			resetAll();
		});

		const onChangeLoggedClientInfo = $rootScope.$on(Vgr.constants.evtChangeLoggedClientInfo, function () {
			resetAll();
		});

		const onChangeLoggedClient = $rootScope.$on(Vgr.constants.evtChangeLoggedClient, function () {
			resetAll();
		});

		const onEvtSearchInVerta = $rootScope.$on(Vgr.constants.evtSearchInVerta, function (evt, errorMessage) {
			_forceRecreation = true;
			$scope.openAgentBar(errorMessage);
		});

		const onLocationChangeSuccess = $scope.$on("$locationChangeSuccess", function () {
			if ($location.search().menu == Vgr.enumerations.homeMenu.vertownAgent) {
				$scope.openAgentBar();

				onLocationChangeSuccess();
			}
		});

		this.$onDestroy = function () {
			// disable the listener
			onChangeLoggedClient();
			onChangeLoggedClientInfo();
			onChangeLoggedUserInfo();
			onLocationChangeSuccess();
			onEvtSearchInVerta();

			// nullify the DOM-bound model
			$scope.domElement = null;
		};
	}
]);
